import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import {
  useGetBarcode,
  usePostCreateBarcode,
  usePutBarcodeData,
} from "../../hooks";
import { HubHookFormWrapper, PageContent } from "../../components";

import BarcodeBuilderPageContent from "./BarcodeBuilderPageContent";
import { barcodeMapper, getBarcodeDefaults } from "./helper";
import { getData_Object } from "../../containers/BarcodeEditorSideBar/helper";

export const BarcodeBuilder = () => {
  const { id } = useParams();
  const passId = !!Number(id);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const { data, isLoading: isGetLoading } = useGetBarcode(passId && id);
  const {
    mutate: postCreateBarcode,
    isLoading: isPostLoading,
    isSuccess,
    data: newBarcode,
  } = usePostCreateBarcode();
  const { mutate: putBarcode, isLoading: isPutLoading } = usePutBarcodeData();
  const isLoading = isGetLoading || isPostLoading || isPutLoading;

  useEffect(() => {
    if (isSuccess && newBarcode?.id) {
      navigate(`/barcodes/${newBarcode?.id}`);
    }
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = barcodeMapper(formData, type);
    if (data?.id) putBarcode({ id, ...payload });
    else postCreateBarcode(payload);
  };

  const sd = getData_Object(data?.object ?? 1);
  const defaultValues = getBarcodeDefaults(data, sd);

  return (
    <PageContent disablePadding isLoading={isGetLoading}>
      <HubHookFormWrapper
        onSubmit={onSubmit}
        sx={{ height: "100%" }}
        defaultValues={defaultValues}
      >
        <BarcodeBuilderPageContent disabled={isLoading} batch={false} />
      </HubHookFormWrapper>
    </PageContent>
  );
};

export default BarcodeBuilder;
